import React from 'react';
import {UserApp} from '../Context/AuthProvider/AuthProviderActions';
import {Avatar, Space} from 'antd';

interface ViewProps {
    user: UserApp
}

export const UserInfo:React.FunctionComponent<ViewProps> = (props) => {
    const {user} = props;

    const AVATAR = React.useMemo(()=>{
        const userImage = user.imagen ? user.imagen : undefined;
        const userInitials = user.imagen ? undefined : `${user.first_name[0]}${user.last_name[0]}`;

        return <Avatar src={ userImage } className='nav-avatar' size={42}>{ userInitials }</Avatar>;
    }, [user.imagen, user.first_name, user.last_name]);

    return (
        <Space align="center">
            { AVATAR }
            <Space direction="vertical" align="start" className='user-nav-info'>
                <div><strong>{`${user.full_name}`}</strong></div>
                <div>{ user.rol }</div>
            </Space>

        </Space>
    );
};
